module.exports = __webpack_public_path__ + "img/writings_img10.76247b41.png";